import React from "react";
import QuotationDashboard from "components/app/crm/dashboard/quotations/QuotationDashboard";

const QuotationDashboardPage = () => <QuotationDashboard />;

export default QuotationDashboardPage;
